import { Action } from 'redux';
import { put } from 'redux-saga/effects';
import { ACTION_CREATOR_NAME, analyticsHelper } from 'helpers';
import { PaymentActionTypes, PaymentActions } from 'store/payment';
import { BasketErrorModel } from 'models/Errors';

const PAYPAL_ERROR_MESSAGE = 'Sorry, there was an error taking the payment from PayPal. Please try again or select a different payment method.';

export interface PaypalRejectAction extends Action<PaymentActionTypes.PAYPAL_REJECT> {
    isError: boolean;
}

export const paypalReject: (isError: boolean) => PaypalRejectAction = (isError: boolean) => ({
    type: PaymentActionTypes.PAYPAL_REJECT,
    isError
});
paypalReject[ACTION_CREATOR_NAME] = 'paypalReject';

export type PaypalRejectFunc = (...args: Parameters<typeof paypalReject>) => void;

export function* paypalRejectSaga({ isError }: PaypalRejectAction) {
    sendAnalytics(isError);
    yield put<PaymentActions>({
        type: PaymentActionTypes.PAYPAL_PAYMENT_ERROR,
        error: isError ? new BasketErrorModel(PAYPAL_ERROR_MESSAGE, undefined, 'paypalRejectSaga') : null
    });
}

function sendAnalytics(isError: boolean): void {
    analyticsHelper.withLogging(() => {
        analyticsHelper.sendToGooglePaypalPaymentStatus(isError ? 'paypalError' : 'paypalCancelled');
    }, 'paypalRejectSaga');
}